import React, {Component} from 'react';
import {DataTable as DataTablePR} from 'primereact/datatable';
import {Column} from 'primereact/column';
import {Badge, Button} from 'reactstrap';
import {Button as ButtonPR} from "primereact/button";
import Translate from "../../../shared/language/Translate";
import PropTypes from 'prop-types';
import TextFormat from "../textFormat/TextFormat";
import DataModelForm from "../form/DataModelForm";
import {APP_DATE_FORMAT, convertDateTimeWithFormat, SERVER_URL} from '../../utils/Constants';
import {Dropdown} from "primereact/components/dropdown/Dropdown";
import Service from "../../service/Service";
import GeneralUtils from "../../utils/GeneralUtils";
import InputText from "../form/InputText";
import exportToExcel from "./export/exportToExcel";
import Loading from "../others/Loading";
import NumberFormat from "../form/NumberFormat";
import PurchaseOrderItemStatusBadge from "../../../module/purchaseorder/PurchaseOrderItemStatusBadge";
import jsPDF from "jspdf";
import "jspdf-autotable";

var filterTimeout = null;
export default class DataTable extends Component {

    constructor(props) {
        super(props);
        this.state = {
            cols: this.props.fields,
            data: this.props.data ? this.props.data : [],
            reportName: this.props.reportName ? this.props.reportName : 'Report',
            parameter: this.props.parameter ? this.props.parameter : null,
            responsive: this.props.responsive != null ? this.props.responsive : false,
            paginator: this.props.paginator != null ? this.props.paginator : true,
            loading: this.props.loading,
            selected: this.props.selectionMode === 'multiple' ? [] : {},
            pageNumber: 0,
            filterElement: [],
            first: 0,
            rows: this.props.rows ? this.props.rows : 10,
            totalRecords: 0,
            sort: [],
            filter: []
        };
    }

    componentWillReceiveProps = (nextProps) => {
        this.setState({cols: nextProps.fields});
        if (!this.props.dataURL) {
            this.setState({data: nextProps.data, loading: nextProps.loading});
        }
    }

    componentDidMount = () => {
        if (this.props.autoLoad !== false) {
            this.init();
        }
        if (this.props.save) {
            this.refForm.setColumns(this.state.cols);
            this.refForm.setData(this.state.selected);
        }
    }

    render() {
        return (<div className="content-section implementation">

            <DataTablePR {...this.props} value={this.state.data} header={this.getHeader()}
                         footer={this.state.paginator == true ? 'Total records: ' + this.state.totalRecords : ''}
                         responsive={this.state.responsive}
                         stripedRows responsiveLayout="scroll"
                         paginator={this.state.paginator}
                         rows={this.state.rows} loading={this.state.loading}
                         totalRecords={this.state.totalRecords}
                         lazy={true}
                         first={this.state.first}
                // onPageChange={this.onPageChange}
                         onPage={this.onPage}
                         sortField={this.state.sortField} sortOrder={this.state.sortOrder} onSort={this.onSort}
                         resizableColumns={true}
                         ref={(el) => {
                             this.dt = el;
                         }}
                         emptyMessage="No Records Found"
                         rowsPerPageOptions={[10, 20, 50]}
                         selectionMode={this.props.selectionMode || 'single'}
                         selection={this.state.selected}
                         onSelectionChange={this.onSelectionChange}
                         onRowSelect={this.onDataSelect}
                         dataKey={this.props.dataKey || 'id'}
                         rowClassName={this.rowClassName}>
                {this.getColumns()}
            </DataTablePR>

            {this.getDataModelForm()}
            {this.state.loadingGlobal && <Loading/>}
        </div>);
    }

    init = () => {
        if (this.props.dataURL) {
            this.setState({
                first: 0,
                rows: this.state.rows,
                filter: [],
                filterElement: [],
                sort: [],
                sortField: null,
                sortOrder: null,
                loading: true
            });

            let gridModel = {"filter": [], "sort": [], "pageNumber": 0, "limit": 10};
            this.findAll(gridModel).then(response => {
                if (!GeneralUtils.isNullOrEmpty(response) && GeneralUtils.isNullOrEmpty(response.type)) {
                    this.setState({
                        data: response.data, totalRecords: response.totalCount ? response.totalCount : 0, loading: false
                    });
                }
            });
        }
    }

    sendEmail = () => {
        if (this.props.dataURL) {
            this.setState({
                first: 0,
                rows: this.state.rows,
                filter: [],
                filterElement: [],
                sort: [],
                sortField: null,
                sortOrder: null,
                loading: true
            });

            let gridModel = {"filter": [], "sort": [], "pageNumber": 0, "limit": 10};
            this.sendReport(gridModel).then(response => {
                this.setState({
                    loading: false
                });
            });
        }

    }

    refresh = () => {
        this.init();
    }

    /**
     * Mevcut filtre ve sıralama state'ini koruyarak sadece veriyi yeniler.
     * Periyodik refresh (örn. 10 sn) için kullanılır - kullanıcının uyguladığı filtre/sort kaybolmaz.
     * @param {Object} filterOverrides - Kolon bazlı filtre override: { fieldName: { value, type, filterMatchMode } }
     */
    reloadWithCurrentState = (filterOverrides = {}) => {
        if (!this.props.dataURL) return;

        let filter = (this.state.filter || []).filter((e) => !filterOverrides[e.name]);
        const filterElement = { ...this.state.filterElement };

        Object.keys(filterOverrides).forEach((name) => {
            const o = filterOverrides[name];
            if (o && !GeneralUtils.__isValueEmpty(o.value)) {
                filter.push({
                    name,
                    value: o.value,
                    type: o.type || "string",
                    filterMatchMode: o.filterMatchMode || "contains"
                });
                filterElement[name] = o.value;
            }
        });

        this.setState({ filter, filterElement, loading: true });

        const gridModel = {
            filter,
            sort: this.state.sort || [],
            pageNumber: this.state.pageNumber ?? 0,
            limit: this.state.rows
        };

        this.findAll(gridModel).then((response) => {
            if (!GeneralUtils.isNullOrEmpty(response) && GeneralUtils.isNullOrEmpty(response.type)) {
                this.setState({
                    data: response.data,
                    totalRecords: response.totalCount != null ? response.totalCount : 0,
                    loading: false
                });
            } else {
                this.setState({ loading: false });
            }
        });
    }

    clear = () => {
        this.setState({
            data: [],
            first: 0,
            rows: this.state.rows,
            filter: [],
            filterElement: [],
            sort: [],
            sortField: null,
            sortOrder: null
        });
    }


    onPage = (event) => {
        let gridModel = {"filter": [], "sort": [], "pageNumber": this.state.pageNumber, "limit": this.state.rows};
        if (event != undefined) {
            gridModel = {
                "filter": this.state.filter, "sort": this.state.sort, "pageNumber": event.page, "limit": event.rows
            };
            this.setState({first: event.first, rows: event.rows, loading: true, pageNumber: event.page});
        }


        this.findAll(gridModel).then(response => {
            if (!GeneralUtils.isNullOrEmpty(response) && GeneralUtils.isNullOrEmpty(response.type)) {
                this.setState({
                    data: response.data, totalRecords: response.totalCount ? response.totalCount : 0, loading: false
                });
            }
        });
    }

    onSort = (e) => {
        let sort = [{name: e.sortField, ascending: e.sortOrder === 1 ? true : false}];
        this.setState({sortField: e.sortField, sortOrder: e.sortOrder, sort: sort, first: 0, loading: true});

        let gridModel = {"filter": this.state.filter, "sort": sort, "pageNumber": 0, "limit": this.state.rows};
        this.findAll(gridModel).then(response => {
            if (!GeneralUtils.isNullOrEmpty(response) && GeneralUtils.isNullOrEmpty(response.type)) {
                this.setState({
                    data: response.data, totalRecords: response.totalCount ? response.totalCount : 0, loading: false
                });
            }
        });
    }

    onModelFilterChange = (event, transient, filterMatchMode) => {
        let name = event.target.name;
        let value = event.value ? event.value : event.target.value;
        let type = event.target.type;
        let filter = this.state.filter;
        filter = filter.filter((e) => e.name !== name);
        filter = filter.filter((e) => e.name !== transient);
        if (!GeneralUtils.__isValueEmpty(value)) {
            if (transient) {
                filter.push({
                    name: transient,
                    value: value,
                    type: GeneralUtils.isNullOrEmpty(type) ? "string" : type,
                    filterMatchMode: filterMatchMode
                });
            } else {
                filter.push({
                    name: name,
                    value: value,
                    type: GeneralUtils.isNullOrEmpty(type) ? "string" : type,
                    filterMatchMode: filterMatchMode
                });
            }
        }
        this.setState({filter: filter, first: 0, loading: true});

        let filterElement = this.state.filterElement;
        filterElement[name] = value;
        this.setState({filterElement: filterElement});

        //implementation goes here
        if (filterTimeout != null) {
            clearTimeout(filterTimeout);
        }
        filterTimeout = setTimeout(() => {
            let gridModel = {"filter": filter, "sort": this.state.sort, "pageNumber": 0, "limit": this.state.rows};
            this.findAll(gridModel).then(response => {
                if (!GeneralUtils.isNullOrEmpty(response) && GeneralUtils.isNullOrEmpty(response.type)) {
                    this.setState({
                        data: response.data, totalRecords: response.totalCount ? response.totalCount : 0, loading: false
                    });
                }
            });
            filterTimeout = null;
        }, 500);
    }

    onModelFilterChangeWithNameAndValue = (name, value, type, transient, filterMatchMode) => {
        let filter = this.state.filter;
        filter = filter.filter((e) => e.name !== name);
        filter = filter.filter((e) => e.name !== transient);
        if (!GeneralUtils.__isValueEmpty(value)) {
            if (transient) {
                filter.push({
                    name: transient,
                    value: value,
                    type: GeneralUtils.isNullOrEmpty(type) ? "string" : type,
                    filterMatchMode: filterMatchMode
                });
            } else {
                filter.push({
                    name: name,
                    value: value,
                    type: GeneralUtils.isNullOrEmpty(type) ? "string" : type,
                    filterMatchMode: filterMatchMode
                });
            }
        }
        this.setState({filter: filter, first: 0, loading: true});

        let filterElement = this.state.filterElement;
        filterElement[name] = value;
        this.setState({filterElement: filterElement});

        //implementation goes here
        if (filterTimeout != null) {
            clearTimeout(filterTimeout);
        }
        filterTimeout = setTimeout(() => {
            let gridModel = {"filter": filter, "sort": this.state.sort, "pageNumber": 0, "limit": this.state.rows};
            this.findAll(gridModel).then(response => {
                if (!GeneralUtils.isNullOrEmpty(response) && GeneralUtils.isNullOrEmpty(response.type)) {
                    this.setState({
                        data: response.data, totalRecords: response.totalCount ? response.totalCount : 0, loading: false
                    });
                }
            });
            filterTimeout = null;
        }, 500);

    }

    getBranchIdHeader = () => {
        if (!GeneralUtils.isNullOrEmpty(this.props.branchId)) {
            return String(this.props.branchId);
        }
        return localStorage.getItem("merchantBranchId");
    }

    async findAll(gridModel) {
        let URL = this.props.dataURL;
        if (this.state.parameter) {
            URL = URL + '/' + this.state.parameter
        }
        try {
            const response = await GeneralUtils.fetchWithAuth(SERVER_URL + URL, {
                crossDomain: true,
                method: 'put',
                headers: { 'Content-Type': 'application/json', 'X-Softrame-BranchId': this.getBranchIdHeader() },
                body: JSON.stringify(gridModel)
            });
            const result = response.clone();
            GeneralUtils.notification(response, true);
            return GeneralUtils.responseToJson(result).catch(err => {
                GeneralUtils.notification(err);
                return [];
            });
        } catch (error) {
            GeneralUtils.notification(error);
            return [];
        }
    }

    async sendReport(gridModel) {
        let URL = this.props.dataURL + '/' + "sendEmail";
        if (this.state.parameter) {
            URL = URL + '/' + this.state.parameter;
        }
        return GeneralUtils.fetchWithAuth(SERVER_URL + URL, {
            crossDomain: true,
            method: 'put',
            headers: { 'Content-Type': 'application/json', 'X-Softrame-BranchId': this.getBranchIdHeader() },
            body: JSON.stringify(gridModel)
        }).then(response => {
            let result = response.clone();
            GeneralUtils.notification(response);
            return GeneralUtils.responseToJson(result);
        }).catch(error => {
            GeneralUtils.notification(error);
        });
    }

    onSelectionChange = (e) => {
        const selected = this.props.selectionMode === 'multiple'
            ? (Array.isArray(e.value) ? e.value : [])
            : Object.assign({}, e.value || {});
        this.setState({selected});
        if (this.props.onSelectionChange) {
            this.props.onSelectionChange(selected);
        }
    }

    clearSelection = () => {
        const selected = this.props.selectionMode === 'multiple' ? [] : {};
        this.setState({selected});
        if (this.props.onSelectionChange) {
            this.props.onSelectionChange(selected);
        }
    }

    save = (data) => {
        if (this.props.save) {
            this.props.save(data);
            this.refForm.setData({});
            this.refForm.close();
        }
        this.setState({selected: {}});
    }

    delete = (data) => {
        this.props.delete(data);
        this.setState({selected: {}});
        this.refForm.setData({});
        this.refForm.close();
    }

    shouldSkipRowSelect = (e) => {
        const target = e?.originalEvent?.target;
        if (!target) {
            return false;
        }
        const element = target.nodeType === 3 ? target.parentElement : target;
        if (!element || typeof element.closest !== 'function') {
            return false;
        }
        return !!element.closest(
            'button, .btn, [class*="btn-"], input, select, textarea, a[href], [role="button"], .p-row-editor-init, .p-row-editor-save, .p-row-editor-cancel'
        );
    }

    onDataSelect = (e) => {
        if (this.props.selectionMode === 'multiple') {
            return;
        }
        if (this.shouldSkipRowSelect(e)) {
            return;
        }
        if (this.props.onDataSelect) {
            this.props.onDataSelect(e.data);
        } else {
            let selected = Object.assign({}, e.data);
            this.setState({
                selected: selected
            });
            if (this.props.save) {
                this.refForm.setData(selected);
                this.refForm.open();
            }
        }
    }

    addNew = () => {
        this.setState({
            selected: {}
        });
        if (this.props.save) {
            this.refForm.setData({});
            this.refForm.open();
        }
    }

    complexCell = (rowData, column, col) => {
        return this.complexCellMultiField(rowData, column, col);
    }

    complexCellMultiField = (rowData, column, col) => {
        let objectName = column.field.split('.')[0];
        let fieldName = column.field.split('.')[1];
        let fieldNameOther = column.field.split('.')[2];
        let content = [];
        if (Array.isArray(rowData[objectName])) {
            rowData[objectName].forEach((obj) => {
                content.push(<Badge style={{marginRight: '5px'}} color="info">&nbsp;{obj[fieldName]}&nbsp;</Badge>);
            });
            return <span>{content}</span>;
        } else {
            if (rowData[objectName]) {
                if (fieldNameOther) {
                    if (rowData[objectName][fieldName]) {
                        content.push(rowData[objectName][fieldName][fieldNameOther]);
                    }
                } else {
                    content.push(rowData[objectName][fieldName]);
                }
            }
            return <span style={{whiteSpace: "nowrap"}} title={content}>{content}</span>;
        }
    }

    dateCell = (rowData, column) => {
        const format = (column.field === 'invoiceDate'
            || column.field === 'createDate'
            || column.field === 'confirmDate'
            || column.field === 'paymentDueDate')
            ? 'DD/MM/YYYY'
            : APP_DATE_FORMAT;
        return (
            <TextFormat
                value={rowData[column.field]}
                type="date"
                format={format}
                blankOnInvalid
            />
        );
    }

    badgeCell = (rowData, column) => {
        return <PurchaseOrderItemStatusBadge item={rowData} centered/>;
    }
    loadingCell = (rowData, column) => {
        const baseStyle = {
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            gap: "4px",
            padding: "2px 6px",
            borderRadius: "6px",
            fontWeight: 600,
            fontSize: "10px",
            minHeight: "22px",
            lineHeight: "14px",
            verticalAlign: "middle",
        };

        const processed = rowData?.processedFileCount;
        const total = rowData?.totalFileCount;
        const invoiceNumber = rowData?.invoiceNumber;

        const canShowSpinner =
            rowData.purchaseOrderStatus === "INVOICE" &&
            rowData.invoiceType === "UPLOAD" &&
            processed != null &&
            total != null &&
            total !== 0 &&
            processed < total;

        if (canShowSpinner && invoiceNumber != "ERROR") {
            return (
                <span className="blinking-badge" style={{ ...baseStyle }}>
                <i
                    className="pi pi-spin pi-spinner"
                    style={{
                        color: "#1982D9",
                        fontSize: "14px",
                        verticalAlign: "middle",
                    }}
                />
            </span>
            );
        }

        if (
            rowData.purchaseOrderStatus === "INVOICE" &&
            invoiceNumber != "ERROR" &&
            rowData.itemCount != null &&
            rowData.itemCount > 0 &&
            (rowData.unsearchedActiveCount == null || rowData.unsearchedActiveCount === 0)
        ) {
            return (
                <span style={{ ...baseStyle }}>
                    <i className="pi pi-check" style={{ color: "#16A34A", fontSize: "14px", verticalAlign: "middle" }} />
                </span>
            );
        }

        return null;
    };


    getMoneyCellHighlight = () => {
        return null;
    };

    moneyCell = (rowData, column) => {
        let value = rowData[column.field];
        if (!GeneralUtils.isNullOrEmpty(rowData["parentBssId"]) && value <= 0 && column.field !== "totalPrice") {
            value = null;
        }

        const highlightColor = this.getMoneyCellHighlight(rowData, column);
        const highlight = highlightColor != null;

        return (
            <NumberFormat
                value={value}
                displayType={"text"}
                thousandSeparator=","
                decimalSeparator="."
                prefix="£"
                decimalScale={2}
                fixedDecimalScale={true}
                renderText={(val) => {
                    if (!highlight) {
                        return <span>{val}</span>;
                    }

                    // Yazı rengini highlightColor'a göre ayarlıyoruz
                    let textColor = "#fff"; // default beyaz
                    if (highlightColor === "#FFCC00") {
                        textColor = "#333333"; // sarı arka planda siyah yazı
                    }

                    return (
                        <span
                            className="highlight-cell"
                            style={{
                                backgroundColor: highlightColor,
                                color: textColor
                            }}
                        >
                        {val}
                    </span>
                    );
                }}
            />
        );
    };

    formatPaymentSummaryMoney = (value) => {
        if (value == null || value === '') {
            return '£0.00';
        }
        const number = Number(value);
        if (Number.isNaN(number)) {
            return String(value);
        }
        return '£' + number.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    };

    paymentSummaryCell = (rowData) => {
        const statusValue = rowData.paymentStatus || 'UNPAID';
        const hasDue = !GeneralUtils.isNullOrEmpty(rowData.paymentDueDate);
        const invoiceTotal = rowData.totalAmount != null && rowData.totalAmount !== ''
            ? Number(rowData.totalAmount)
            : (Number(rowData.paidAmount || 0) + Number(rowData.remainingAmount || 0));
        const paidAmount = Number(rowData.paidAmount || 0);
        const dueSuffix = hasDue ? (
            <span className="po-payment-summary-cell__due">
                {' · Due '}
                <TextFormat value={rowData.paymentDueDate} type="date" format="DD/MM/YYYY" blankOnInvalid/>
            </span>
        ) : null;

        if (statusValue === 'PAID') {
            return (
                <span className="po-payment-summary-cell po-payment-summary-cell--paid">
                    Paid
                </span>
            );
        }

        if (statusValue === 'PARTIAL') {
            return (
                <span className="po-payment-summary-cell po-payment-summary-cell--partial">
                    {this.formatPaymentSummaryMoney(paidAmount)}
                    {' of '}
                    {this.formatPaymentSummaryMoney(invoiceTotal)}
                    {' paid'}
                    {dueSuffix}
                </span>
            );
        }

        return (
            <span className="po-payment-summary-cell po-payment-summary-cell--unpaid">
                <span className="po-payment-summary-cell__status">Unpaid</span>
                {dueSuffix}
            </span>
        );
    };

    multipleLinesCell = (rowData, column) => {
        let value = rowData[column.field];

        if (!GeneralUtils.isNullOrEmpty(value)) {
            let content = [];
            if (!GeneralUtils.isNullOrEmpty(rowData["parentBssId"])) {
                content.push(
                    <span>&nbsp;&nbsp;&nbsp;&nbsp;{value}</span>
                );
            } else {
                content.push(
                    <span><b>{value}</b></span>
                );
            }
            if (!GeneralUtils.isNullOrEmpty(rowData["extraNotes"])) {
                content.push(
                    <br></br>
                );
                content.push(
                    <br></br>
                );
                content.push(
                    <span>&nbsp;&nbsp;&nbsp;&nbsp;Notes:{rowData["extraNotes"]}</span>
                );
                content.push(
                    <br></br>
                );

            }

            return <span>{content}</span>;
        }
    }

    multipleLinesForKitchenCell = (rowData, column) => {
        let value = rowData[column.field];

        if (!GeneralUtils.isNullOrEmpty(value)) {
            let content = [];
            if (rowData["header"] == true) {
                content.push(
                    <span><b>{value}</b></span>
                );
            } else {
                if (!GeneralUtils.isNullOrEmpty(rowData["parentBssId"])) {
                    content.push(
                        <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{value}</span>
                    );
                } else {
                    content.push(
                        <span><b>&nbsp;&nbsp;&nbsp;{value}</b></span>
                    );
                }
            }
            if (!GeneralUtils.isNullOrEmpty(rowData["extraNotes"])) {
                content.push(
                    <br></br>
                );
                content.push(
                    <br></br>
                );
                content.push(
                    <span>&nbsp;&nbsp;&nbsp;&nbsp;Notes:{rowData["extraNotes"]}</span>
                );
                content.push(
                    <br></br>
                );

            }

            return <span>{content}</span>;
        }
    }

    quantityCell = (rowData, column) => {
        if (!GeneralUtils.isNullOrEmpty(rowData["parentBssId"])) {
            return <span>{rowData[column.field]}</span>;
        }

        return (
            <span className="checkout-qty-control">
                <ButtonPR
                    type="button"
                    icon="pi pi-minus"
                    className="p-button-primary checkout-qty-btn"
                    onClick={() => this.actionOnclick(rowData, "subtract")}
                />
                <span className="checkout-qty-value">{rowData[column.field]}</span>
                <ButtonPR
                    type="button"
                    icon="pi pi-plus"
                    className="p-button-primary checkout-qty-btn"
                    onClick={() => this.actionOnclick(rowData, "add")}
                />
            </span>
        );
    }

    quantityItemCell = (rowData, column) => {
        let content = [];
        if (!GeneralUtils.isNullOrEmpty(rowData["price"])) {
            content.push(rowData[column.field]);
        }
        return <span style={{display: 'block', textAlign: 'left'}}>{content}</span>;
    }
    quantityItemForKitchenCell = (rowData, column) => {
        let content = [];
        if (rowData["header"] == false) {
            content.push(rowData[column.field]);
        }
        return <span style={{display: 'block', textAlign: 'right'}}>{content}</span>;
    }

    actionOnclick = (rowData, functionName) => {
        if (this.props[functionName]) {
            this.props[functionName](rowData);
        }
    }


    durationCell = (rowData, column) => {
        return <NumberFormat value={rowData[column.field]} displayType={'text'}
                             decimalSeparator=","
                             decimalScale={2} fixedDecimalScale={true}/>
    }

    percentCell = (rowData, column) => {
        return <NumberFormat value={rowData[column.field]} displayType={'text'} thousandSeparator={true} prefix={'% '}
                             decimalScale={2} fixedDecimalScale={true}
                             renderText={value => <span style={{float: "right"}}>{value}</span>}/>
    }

    dataElementCell = (rowData, column) => {
        return rowData[column.field];
    }

    onStatusChange = (event) => {
        this.dt.filter(event.value, event.target.name, 'equals');
        let filterElement = this.state.filterElement;
        filterElement[event.target.name] = event.value;
        this.setState({filterElement: filterElement});
        this.onModelFilterChange(event);
    }

    getOptions = (restURL) => {
        let options = null;
        this.service = new Service(restURL);
        this.service.findAll().then(response => options = response);
        return options;
    }


    export = () => {
        this.exportXLSX();
    }

    exportPdf = () => {
        this.setState({loadingGlobal: true});
        let gridModel = {"filter": this.state.filter, "sort": this.state.sort, "pageNumber": 0, "limit": -1};

        this.findAll(gridModel).then(response => {
            let data = response.data;
            let columns = this.state.cols;

            const headers = [[]];
            const fields = [[]];
            var len = columns.length;

            for (var i = 0; i < len; i++) {
                if (columns[i].field && columns[i].visible !== false && columns[i].isButton !== true) {
                    headers[0].push(columns[i].header);
                    fields[0].push(columns[i].field);

                }
            }
            const unit = "pt";
            const size = "A4"; // Use A1, A2, A3 or A4
            const orientation = "portrait"; // portrait or landscape

            const marginLeft = 40;
            const doc = new jsPDF(orientation, unit, size);

            doc.setFontSize(15);

            const title = this.state.reportName;

            /*const data1 = data.map(elt=>
                [elt.name, elt.quantity,elt.amount]
            );*/

            var newData = [];
            data.forEach(dataEach => {
                var tempData = [];
                for (var j = 0; j < fields[0].length; j++) {
                    tempData.push(dataEach[fields[0][j]]);
                }
                newData.push(tempData);
            })

            let content = {
                startY: 50,
                head: headers,
                body: newData
            };

            doc.text(title, marginLeft, 40);
            doc.autoTable(content);
            doc.save(this.state.reportName + ".pdf");

            this.setState({loadingGlobal: false});
        });
    }

    exportXLSX = () => {
        this.setState({loadingGlobal: true});
        //let exportFilename = "download" + convertDateTimeWithFormat(Date.now(), 'DD.MM.YYYY_HH.mm');
        let exportFilename = this.state.reportName;
        let gridModel = {"filter": this.state.filter, "sort": this.state.sort, "pageNumber": 0, "limit": -1};
        this.findAll(gridModel).then(response => {
            let data = response.data;
            let columns = this.state.cols;

            let dataAll = [];
            var len = columns.length;
            data.forEach((record, j) => {
                let dataTemp = {};
                for (var i = 0; i < len; i++) {
                    if (columns[i].field && columns[i].visible !== false && columns[i].isButton !== true) {
                        // '"' + (columns[i].header || columns[i].field) + '"'
                        // '"' + this.check(this.resolveFieldData(record, columns[i])) + '"'
                        dataTemp[(columns[i].header || columns[i].field)] = this.check(this.resolveFieldData(record, columns[i]));
                    }
                }
                dataAll.push(dataTemp);
            });
            exportToExcel(dataAll, exportFilename);
            this.setState({loadingGlobal: false});
        });
    }

    exportCSV() {
        this.setState({loadingGlobal: true});
        let exportFilename = "download" + convertDateTimeWithFormat(Date.now(), 'DD.MM.YYYY_HH.mm');
        let csvSeparator = ',';
        let gridModel = {"filter": this.state.filter, "sort": this.state.sort, "pageNumber": 0, "limit": -1};
        this.findAll(gridModel).then(response => {
            let data = response.data;
            let csv = '\ufeff';
            let columns = this.state.cols;

            //headers
            for (let i = 0; i < columns.length; i++) {
                if (columns[i].field && columns[i].visible !== false) {
                    csv += '"' + (columns[i].header || columns[i].field) + '"';

                    if (i < (columns.length - 1)) {
                        csv += csvSeparator;
                    }
                }
            }

            //body
            data.forEach((record, j) => {
                csv += '\n';
                for (let i = 0; i < columns.length; i++) {
                    if (columns[i].field && columns[i].visible !== false) {
                        csv += '"' + this.check(this.resolveFieldData(record, columns[i])) + '"';

                        if (i < (columns.length - 1)) {
                            csv += csvSeparator;
                        }
                    }
                }
            });

            let blob = new Blob([csv], {
                type: 'text/csv;charset=utf-8;'
            });

            if (window.navigator.msSaveOrOpenBlob) {
                navigator.msSaveOrOpenBlob(blob, exportFilename + '.csv');
            } else {
                let link = document.createElement("a");
                link.style.display = 'none';
                document.body.appendChild(link);
                if (link.download !== undefined) {
                    link.setAttribute('href', URL.createObjectURL(blob));
                    link.setAttribute('download', exportFilename + '.csv');
                    link.click();
                } else {
                    csv = 'data:text/csv;charset=utf-8,' + csv;
                    window.open(encodeURI(csv));
                }
                document.body.removeChild(link);
            }
            this.setState({loadingGlobal: false});
        });

    }

    resolveFieldData(data, col) {
        if (data && col.field) {
            if (col.formatMoney) {
                return data[col.field];
            } else if (col.formatPercent) {
                return data[col.field];
            } else if (col.field.includes('.')) {
                let fields = col.field.split('.');
                let value = data;
                for (var i = 0, len = fields.length; i < len; ++i) {
                    if (value == null) {
                        return null;
                    }
                    value = value[fields[i]];
                }
                return value;
            } else if (col.field.toUpperCase().includes('DATE')) {
                return convertDateTimeWithFormat(data[col.field], APP_DATE_FORMAT)
            } else if (col.field.toUpperCase().includes('IMAGE')) {
                return null;
            }
            if (col.dataElement) {
                return col.dataElement[data[col.field]]
            } else if (this.isFunction(col.field)) {
                return col.field(data);
            } else {
                return data[col.field];
            }
        } else {
            return null;
        }
    }

    isFunction(obj) {
        return !!(obj && obj.constructor && obj.call && obj.apply);
    }

    check(value) {
        return !GeneralUtils.__isValueEmpty(value) ? value : "";
    }

    rowClassName = (rowData) => {
        let status = rowData.status;
        if (rowData.orderStatus == "ORDER_PLACED") {
            return {'highlightTableRowGreen': true};
        } else if ((rowData.showWarningActive && rowData.syncStatus == "FAILED") ) {
            return {'highlightTableRow': true};
        } else if (rowData.showWarningActive && rowData.colourCode == "red") {
            return {'highlightTableRowRed': true};
        } else if (rowData.showWarningActive && rowData.colourCode == "green") {
            return {'highlightTableRowGreen': true};
        } else if (rowData.showWarningActive && rowData.colourCode == "yellow") {
            return {'highlightTableRowYellow': true};
        } else if (rowData.basketType == "refund") {
            return {'highlightTableRowRefund': true};
        }
        else if (rowData.orderStatus==null && rowData.showWarningActive && rowData.itemBssId == null){
            //return {'highlightTableYellow': true};
        }
        return {'p-disabled': (status === 'PASSIVE')};
    }

    getColumns = () => {
        let columns = [];
        if (this.props.selectionMode === 'multiple') {
            columns.push(
                <Column key="__selection"
                        selectionMode="multiple"
                        style={{width: '3em'}}
                        headerStyle={{width: '3em'}}/>
            );
        }
        this.state.cols.forEach((col) => {

            if (col.visible !== false) {
                if (col.field.includes('.')) {
                    let modelFilter = <InputText style={{width: '100%'}} className="ui-column-filter" name={col.field}
                                                 type={col.type}
                                                 value={this.state.filterElement[col.field]}
                                                 onChange={e => this.onModelFilterChange(e, col.transient)}/>
                    columns.push(<Column key={col.field} field={col.field} header={col.header} filter={col.filter}
                                         body={(rowData, column) => this.complexCell(rowData, column, col)}
                                         filterMatchMode="contains" sortable={col.sortable} style={col.style}
                                         filterElement={modelFilter}/>)
                } else if (col.field.toUpperCase().includes('DATE')) {
                    let modelFilter = <InputText style={{width: '100%'}} className="ui-column-filter" name={col.field}
                                                 type={col.type}
                                                 value={this.state.filterElement[col.field]}
                                                 onChange={this.onModelFilterChange}/>
                    columns.push(<Column key={col.field} field={col.field} header={col.header} filter={col.filter}
                                         body={this.dateCell}
                                         filterMatchMode="contains" sortable={col.sortable} style={col.style}
                                         filterElement={modelFilter}/>)
                } else if (col.filterElement && col.filter !== false) {
                    let options = null;
                    if (col.filterElement.restURL) {
                        this.getOptions(col.filterElement.restURL);
                    } else {
                        options = col.filterElement.options;
                    }
                    let dropdownFilter = <Dropdown style={{width: '100%'}} name={col.field}
                                                   value={this.state.filterElement[col.field]} options={options}
                                                   onChange={e => this.onModelFilterChange(e, null, col.filterMatchMode)}/>

                    if (col.dataElement) {
                        columns.push(<Column key={col.field} field={col.field} header={col.header} filter={col.filter}
                                             filterElement={dropdownFilter}
                                             body={(rowData, column) => {
                                                 return col.dataElement[this.dataElementCell(rowData, column)]
                                             }}
                                             filterMatchMode="equals" sortable={col.sortable} style={col.style}
                                             editor={this.props[col.editor]}/>)
                    } else {
                        let modelFilter = <InputText style={{width: '100%'}} className="ui-column-filter"
                                                     type={col.type}
                                                     name={col.field} value={this.state.filterElement[col.field]}
                                                     onChange={this.onModelFilterChange}/>
                        columns.push(<Column key={col.field} field={col.field} header={col.header} filter={col.filter}
                                             filterMatchMode="contains" sortable={col.sortable} style={col.style}
                                             filterElement={modelFilter}/>);
                    }
                } else if (col.paymentSummary) {
                    columns.push(<Column key={col.field} field={col.field} header={col.header}
                                         body={this.paymentSummaryCell}
                                         sortable={false}
                                         filter={false}
                                         style={col.style}/>)
                } else if (col.formatMoney) {
                    columns.push(<Column key={col.field} field={col.field} header={col.header} filter={col.filter}
                                         body={this.moneyCell}
                                         filterMatchMode="contains" sortable={col.sortable} style={col.style}
                                         filterElement={col.filter !== false
                                             ? <InputText style={{width: '100%'}} className="ui-column-filter" name={col.field}
                                                          type={col.type}
                                                          value={this.state.filterElement[col.field]}
                                                          onChange={this.onModelFilterChange}/>
                                             : undefined}/>)
                } else if (col.multipleLines) {
                    columns.push(<Column key={col.field} field={col.field} header={col.header} filter={col.filter}
                                         body={this.multipleLinesCell}
                                         filterMatchMode="contains" sortable={col.sortable} style={col.style}/>)
                } else if (col.multipleLinesForKitchen) {
                    columns.push(<Column key={col.field} field={col.field} header={col.header} filter={col.filter}
                                         body={this.multipleLinesForKitchenCell}
                                         filterMatchMode="contains" sortable={col.sortable} style={col.style}/>)
                }
                else if (col.formatItemQuantityForKitchen) {
                    columns.push(<Column key={col.field} field={col.field} header={col.header} filter={col.filter}
                                         body={this.quantityItemForKitchenCell}
                                         filterMatchMode="contains" sortable={col.sortable} style={col.style}/>)
                }
                else if (col.formatDuration) {
                    let modelFilter = <InputText style={{width: '100%'}} className="ui-column-filter" name={col.field}
                                                 type={col.type}
                                                 value={this.state.filterElement[col.field]}
                                                 onChange={this.onModelFilterChange}/>
                    columns.push(<Column key={col.field} field={col.field} header={col.header} filter={col.filter}
                                         body={this.durationCell}
                                         filterMatchMode="contains" sortable={col.sortable} style={col.style}
                                         filterElement={modelFilter}/>)
                } else if (col.formatPercent) {
                    let modelFilter = <InputText style={{width: '100%'}} className="ui-column-filter" name={col.field}
                                                 type={col.type}
                                                 value={this.state.filterElement[col.field]}
                                                 onChange={this.onModelFilterChange}/>
                    columns.push(<Column key={col.field} field={col.field} header={col.header} filter={col.filter}
                                         body={this.percentCell}
                                         filterMatchMode="contains" sortable={col.sortable} style={col.style}
                                         filterElement={modelFilter}/>)
                } else if (col.field.toUpperCase().includes('IMAGE')) {
                    columns.push(<Column key={col.field} field={col.field} header={col.header}
                                         body={this.imageCell}
                                         filterMatchMode="contains" style={col.style}/>)
                } else if (col.field.toUpperCase().includes('LOADING')) {
                    columns.push(<Column key={col.field} field={col.field} header={col.header}
                                         body={this.loadingCell}
                                         filterMatchMode="contains" style={col.style}/>)
                }
                else {
                    if (col.dataElement) {
                        let modelFilter = <InputText style={{width: '100%'}} className="ui-column-filter"
                                                     type={col.type}
                                                     name={col.field} value={this.state.filterElement[col.field]}
                                                     onChange={this.onModelFilterChange}/>
                        columns.push(<Column key={col.field} field={col.field} header={col.header} filter={col.filter}
                                             body={(rowData, column) => {
                                                 return col.dataElement[this.dataElementCell(rowData, column)]
                                             }}
                                             filterMatchMode="equals" sortable={col.sortable} style={col.style}
                                             filterElement={modelFilter}/>)
                    } else {
                        let modelFilter = <InputText style={{width: '100%'}} className="ui-column-filter"
                                                     type={col.type}
                                                     name={col.field} value={this.state.filterElement[col.field]}
                                                     onChange={e => this.onModelFilterChange(e, col.transient)}/>
                        columns.push(<Column key={col.field} field={col.field} header={col.header} filter={col.filter}
                                             filterMatchMode="contains" sortable={col.sortable} style={col.style}
                                             body={(rowData, column) => {
                                                 let text = rowData[column.field]
                                                 const spanStyle = {
                                                     whiteSpace: col.style?.whiteSpace ?? "nowrap",
                                                     ...(col.style?.wordBreak ? {wordBreak: col.style.wordBreak} : {})
                                                 };
                                                 return <span style={spanStyle} title={text}>{text}</span>
                                             }}
                                             editor={this.props[col.editor]} filterElement={modelFilter}/>);
                    }
                }
            }
        });
        return columns;
    }


    getHeader = () => {
        if (this.props.header || this.props.export || this.props.refresh) {
            return <div className="p-clearfix"
                        style={{lineHeight: '1.87em'}}>
                {this.state.totalRecords > 0 && this.props.export && this.getExportButton()}
                {this.props.header}
                {this.getAddNewButton()}
                {this.props.refresh != false ? this.getRefreshButton() : ''}
            </div>;
        }
    }

    getAddNewButton = () => {
        if (this.props.save) {
            return <Button style={{float: 'right'}} color="primary" onClick={this.addNew}>
                &nbsp;
                <Translate contentKey="entity.action.add">Yeni Kayıt</Translate>
            </Button>;
        }
    }

    getExportButton = () => {
        if (this.props.export) {
            return <Button style={{float: 'left', color: '#1982D9', backgroundColor: 'white', width: '140px'}}
                           onClick={this.export} className="pi pi-file-excel">
                &nbsp;
                <Translate contentKey="entity.action.csv">Export To CSV</Translate>
            </Button>;
        }
    }

    getRefreshButton = () => {
        return <ButtonPR icon="pi pi-refresh" style={{'float': 'right'}} onClick={this.refresh}/>
    }

    getDataModelForm = () => {
        let result;
        if (this.props.save) {
            result = (<DataModelForm ref={(elem) => this.refForm = elem} save={this.save} delete={this.props.delete}
                                     inDialog={this.props.inDialog}/>);
        }
        return result;
    }

    setParameter = (...parameter) => {
        this.state.parameter = parameter.reduce((previous, current) => {
            return previous + '/' + current;
        });
        this.forceUpdate();

        this.refresh();
    }

    getData = () => {
        return this.state.data;
    }

    setData = (data) => {
        this.setState({data: data})
    }
}
DataTable.propTypes = {
    header: PropTypes.string,
    fields: PropTypes.array.isRequired,
    dataURL: PropTypes.string,
    save: PropTypes.func,
    delete: PropTypes.func,
    selectionMode: PropTypes.string,
    onDataSelect: PropTypes.func,
    onSelectionChange: PropTypes.func,
    branchId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    dataKey: PropTypes.string,
    export: PropTypes.bool,
    exportPdf: PropTypes.bool
};

DataTable.defaultProps = {
    header: null, fields: [], data: []
};
